module.exports = __webpack_public_path__ + "static/media/backButton.43139431.svg";